<template>
  <FilterItemMobile>
    <template #filter-item-content>
      <div class="filter-item-label">{{ $t('dictionary.price') }}</div>
      <PriceRangeFilterContainer
        :min-range="priceRange.minPrice / 100"
        :max-range="priceRange.maxPrice / 100"
        :is-reset="isReset"
        class="price-range-filter"
        @resetted="$emit('resetted')"
      />
    </template>
  </FilterItemMobile>
</template>

<script>
import { mapGetters } from 'vuex'
import FilterItemMobile from './FilterItemMobile.vue'
import PriceRangeFilterContainer from './PriceRangeFilterContainer.vue'

export default {
  name: 'PriceRangeFilterContainerMobile',

  components: {
    FilterItemMobile,
    PriceRangeFilterContainer
  },

  props: {
    isReset: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters({
      priceRange: 'listingPageFilters/priceRangeFilter'
    })
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .slider {
    margin-top: 30px;
  }
}
</style>
